//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const ShowDataRetentionSettings: FeatureFlag = {"Id":"ShowDataRetentionSettings","Label":"[10.25]Show and allow editing of tenant data retention settings","Impact":"Exposes the Data Retention heading/settings on the Tenants edit page for viewing and editing","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
